module.exports = __webpack_public_path__ + "static/media/13d.68b96a79.png";